// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ErEf","left":"styles_left__Nd8I0"};